import { FC } from 'react'

import { Button, Typography } from '@/components/ui'

import ExclamMark from '@/assets/icons/red-exclamation-mark.svg'

interface ITranslateErrorProps {
	tryCallback?: () => void
	closeButtonText?: string
	closeCallback?: () => void
}

const TranslateError: FC<ITranslateErrorProps> = ({
	tryCallback,
	closeButtonText = 'Close',
	closeCallback
}) => {
	return (
		<div className='flex flex-col gap-5'>
			<ExclamMark className='mx-auto' />
			<div className='flex flex-col gap-2 mx-auto'>
				<Typography
					variant='text-semibold'
					className='!text-[16px] text-center'
				>
					Something went wrong
				</Typography>
				<Typography variant='text-large' className='text-center'>
					Please try again later or check your <br />
					internet connection
				</Typography>
			</div>
			<div className='flex gap-2 mx-auto'>
				<Button
					className='!bg-gray-100 hover:!bg-gray-200 !rounded-[8px] !text-black !p-[10px]'
					classNameText='!text-[16px]'
					onClick={tryCallback}
				>
					Try again
				</Button>
				<Button
					className='!bg-black hover:!bg-gray-500 !rounded-[8px] !text-white !p-[10px]'
					classNameText='!text-[16px]'
					onClick={closeCallback}
				>
					{closeButtonText}
				</Button>
			</div>
		</div>
	)
}

export default TranslateError
